import { PageProps } from '..'
import { useProjectPrivateContext } from '../../context/projectContext'
import ProfitLossSummaryView from './view'
import { projectPrivate } from '../../higher-order-components/projectPrivate'

type Props = PageProps

const ProfitLossSummary = (props: Props) => {
  const { project } = useProjectPrivateContext()

  return <ProfitLossSummaryView {...props} currentProject={project} />
}

export default projectPrivate(ProfitLossSummary)
